import { tau } from "./math";

export function degreeToRadian(degree) {
    return degree * (Math.PI / 180);
}

export function radianToDegree(radian) {
    return 180 * radian / Math.PI;
}

export const clampRadian = (angle = 0) => {
    if (angle < 0) for (;angle < -tau; ) angle += tau; else if (angle > 0) for (;angle > tau; ) angle -= tau;
    return angle;
};

export const clampAngleByRadian = clampRadian;

export const clampDegree = (a = 0) => a > 360 || a < -360 ? a % 360 : a;

export const clampAngleByDegree = clampDegree;

export function polarToCartesian(center, radius, angleInRadian) {
    return {
        x: center.x + radius * Math.cos(angleInRadian),
        y: center.y + radius * Math.sin(angleInRadian)
    };
}

export function getAngleByPoint(center, point) {
    return Math.atan2(point.y - center.y, point.x - center.x);
}